import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../configuration/tokenHandling/prepareHeaders";

export interface CheckupSchedule {
	scheduledDate: string | null;
	odometer: number;
	hourmeter?: number;
	state?: string;
	id?: string;
}

export interface CheckupType {
	id: string;
	name: string;
	services: string[];
}

export interface CheckupRange {
	start: number;
	end: number | null;
}

export interface Checkup {
	range: CheckupRange;
	maintenanceGroupId: string | null;
	checkupType: CheckupType;
	type: string | null;
	hasCampaigns: boolean | null;
}

export interface NextCheckup {
	canSchedule: boolean;
	title: string;
	checkup: Checkup;
	schedule: CheckupSchedule;
	maintenance: any | null;
}

export interface PreviousCheckup {
	schedule: CheckupSchedule;
	title: string;
	reason?: string;
}

export interface VehicleCheckupRequest {
	identification: string;
	id: string;
}

export interface VehicleCheckupResponse {
	previousCheckups: PreviousCheckup[];
	nextCheckups: NextCheckup[];
}

const vehicleCheckupBaseQuery = fetchBaseQuery({
	baseUrl: import.meta.env.VITE_VEHICLE_CHECKUP_BASE_URL,
	prepareHeaders: (headers) => prepareHeaders(headers),
});

export const vehicleCheckupApi = createApi({
	reducerPath: "vehicleCheckupApi",
	baseQuery: vehicleCheckupBaseQuery,
	endpoints: (builder) => ({
		getVehicleCheckupHistory: builder.mutation<VehicleCheckupResponse[], { assets: VehicleCheckupRequest[] }>({
			query: (requestPayload) => ({
				url: "/v1/vehicle-checkup/batch",
				method: "POST",
				body: requestPayload,
			}),
		}),
	}),
});

export const { useGetVehicleCheckupHistoryMutation } = vehicleCheckupApi;
